import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';

// ส่วนหัวกลางของทุกหน้า: ไอคอน + หัวข้อ + คำอธิบาย, การ์ดจำนวน, ช่องค้นหา, ปุ่มเพิ่มเติม และแถวล่าง (children)
export function SearchBox({ onChange, placeholder = 'Search Journal by Id', width = 360 }) {
    return (
        <Box sx={{
            display: 'flex', alignItems: 'center', gap: 1,
            width, maxWidth: '100%', px: 1.75, py: 0.75,
            borderRadius: 999, border: '1px solid #e3e6ea', bgcolor: '#f4f6f9',
            transition: 'border-color .15s, box-shadow .15s, background-color .15s',
            '&:focus-within': { borderColor: '#90caf9', bgcolor: '#fff', boxShadow: '0 0 0 3px rgba(30,136,229,0.12)' },
        }}>
            <SearchIcon sx={{ color: '#90a4ae' }} />
            <InputBase
                sx={{ flex: 1, fontSize: 14 }}
                placeholder={placeholder}
                inputProps={{ 'aria-label': 'search' }}
                onChange={onChange}
            />
        </Box>
    );
}

export function CountCard({ label = 'รายการทั้งหมด', value, color = '#43a047' }) {
    return (
        <Box sx={{
            display: 'flex', alignItems: 'center', gap: 1.5,
            px: 2, py: 1.25, borderRadius: 2.5,
            bgcolor: `${color}12`, border: `1px solid ${color}33`,
        }}>
            <Box sx={{ width: 38, height: 38, borderRadius: 2, bgcolor: color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FormatListBulletedRoundedIcon sx={{ fontSize: 22 }} />
            </Box>
            <Box sx={{ lineHeight: 1.15 }}>
                <Box sx={{ fontSize: 12, color, fontWeight: 600, opacity: 0.85 }}>{label}</Box>
                <Box sx={{ fontSize: 22, color, fontWeight: 800 }}>{value}</Box>
            </Box>
        </Box>
    );
}

export default function PageHeader({
    title,
    subtitle,
    icon: Icon,
    color = '#1e88e5',
    gradient,
    count,
    countLabel,
    onSearch,
    searchPlaceholder,
    actions,
    children,
}) {
    return (
        <Paper elevation={0} sx={{ p: 2.5, mb: 2.5, borderRadius: 3, border: '1px solid #e3e6ea', bgcolor: '#fff' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.75 }}>
                    {Icon && (
                        <Box sx={{
                            width: 52, height: 52, borderRadius: 3, flexShrink: 0,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            background: gradient || `linear-gradient(135deg, ${color} 0%, ${color}b3 100%)`,
                            boxShadow: `0 6px 14px ${color}47`,
                        }}>
                            <Icon sx={{ color: '#fff', fontSize: 28 }} />
                        </Box>
                    )}
                    <Box>
                        <Box sx={{ fontSize: 26, fontWeight: 800, color: '#263238', lineHeight: 1.2 }}>{title}</Box>
                        {subtitle && <Box sx={{ fontSize: 13.5, color: '#78909c', mt: 0.25 }}>{subtitle}</Box>}
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    {count !== undefined && <CountCard label={countLabel} value={count} />}
                    {onSearch && <SearchBox onChange={onSearch} placeholder={searchPlaceholder} />}
                    {actions}
                </Box>
            </Box>

            {children && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mt: 2.5, pt: 2, borderTop: '1px solid #f1f3f5', flexWrap: 'wrap' }}>
                    {children}
                </Box>
            )}
        </Paper>
    );
}
